<template>
    <section id="dosing">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange"></span>
                <h1 class="gtitle fw-semibold">
                    Once-daily
                    <span class="text-nowrap omnes">JORNAY PM</span> offers
                    multiple dosage options for dose optimization<sup
                        class="omnes"
                        >1</sup
                    >
                </h1>
            </div>

            <div class="content limitations mt-4">
                <div class="col-12 p-0">
                    <ul class="">
                        <li class="mb-2 mb-lg-0">
                            JORNAY PM is a <b>once-daily capsule</b> that should
                            be <b>taken in the evening</b>. In clinical trials,
                            the
                            <b
                                >most common dosing time was 8
                                <span class="pm">PM</span></b
                            ><sup>1</sup>
                        </li>
                        <li class="mb-2 mb-lg-0">
                            The
                            <b
                                >recommended starting dose for patients 6 years
                                and older is 20 mg</b
                            >
                            each evening<sup>1</sup>
                        </li>
                        <li class="mb-2 mb-lg-0">
                            Dose may be
                            <b>titrated weekly in 20-mg/day increments</b> up to
                            a maximum daily dose of 100 mg/day<sup>1</sup>.
                            <strong
                                >A daily dose above 100 mg has not been studied
                                or recommended</strong
                            >
                        </li>
                        <li>
                            In the pivotal Phase 3 dose optimization study
                            (Study 1), the
                            <b>mean final dose was 66.2 mg/day</b><sup>1,2</sup>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="top-banner">
            <div class="page-container">
                <img
                    src="@/assets/img/dosing/top-banner-image.png"
                    class=""
                    alt="Four sketches of a adult female participating in various activities throughout their day"
                />

                <a
                    target="_blank"
                    href="/JORNAY PM Dosing Guide (Digital).pdf"
                    class="fw-bold"
                >
                    <span class="">Download Dosing Guide</span>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20.082"
                        height="20.082"
                        viewBox="0 0 20.082 20.082"
                    >
                        <path
                            id="download_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                            d="M170.041-784.939l-6.276-6.276,1.757-1.82,3.263,3.263V-800h2.51v10.229l3.263-3.263,1.757,1.82Zm-7.531,5.021a2.417,2.417,0,0,1-1.773-.737,2.417,2.417,0,0,1-.737-1.773v-3.765h2.51v3.765h15.062v-3.765h2.51v3.765a2.417,2.417,0,0,1-.737,1.773,2.417,2.417,0,0,1-1.773.737Z"
                            transform="translate(-160 800)"
                            fill="#fff"
                        />
                    </svg>
                </a>
            </div>
        </div>

        <div class="container">
            <div class="content img-container py-2">
                <p>
                    Percentage of patients by optimized dose at
                    end-of-dose-optimization phase of Study 1<sup>3</sup>
                </p>
                <img
                    class="d-none d-lg-block"
                    src="../../assets/img/dosing/capsules.png"
                    alt="Five JORNAY PM (methylphenidate HCI) capsules for each dose from 20mg to 100 mg"
                />
                <img
                    class="d-block d-lg-none"
                    src="../../assets/img/dosing/capsules-mobile.png"
                    alt="Five JORNAY PM (methylphenidate HCI) capsules for each dose from 20mg to 100 mg"
                />
            </div>
        </div>

        <div class="">
            <div class="page-container">
                <div class="optimized-container">
                    <h2 class="">
                        <img
                            src="@/assets/img/dosing/75.svg"
                            alt="75%"
                            width="130"
                            height="130"
                        />

                        <span>
                            of patients were optimized at 60 mg and above.<sup
                                >3</sup
                            >
                        </span>
                    </h2>

                    <!-- <a
                        target="_blank"
                        href="/JORNAY PM Dosing Guide (Digital).pdf"
                        class="fw-bold"
                    >
                        <span class="">Download Dosing Guide</span>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20.082"
                            height="20.082"
                            viewBox="0 0 20.082 20.082"
                        >
                            <path
                                id="download_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                                d="M170.041-784.939l-6.276-6.276,1.757-1.82,3.263,3.263V-800h2.51v10.229l3.263-3.263,1.757,1.82Zm-7.531,5.021a2.417,2.417,0,0,1-1.773-.737,2.417,2.417,0,0,1-.737-1.773v-3.765h2.51v3.765h15.062v-3.765h2.51v3.765a2.417,2.417,0,0,1-.737,1.773,2.417,2.417,0,0,1-1.773.737Z"
                                transform="translate(-160 800)"
                                fill="#fff"
                            />
                        </svg>
                    </a> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>
